import { render, staticRenderFns } from "./RemovePopUp.vue?vue&type=template&id=205087e3&scoped=true&"
import script from "./RemovePopUp.vue?vue&type=script&lang=js&"
export * from "./RemovePopUp.vue?vue&type=script&lang=js&"
import style0 from "./RemovePopUp.vue?vue&type=style&index=0&id=205087e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205087e3",
  null
  
)

export default component.exports